import { ReactElement } from 'react';
import type { RangeSliderProps } from '@mantine/core';
import { RangeSlider as MantineRangeSlider } from '@mantine/core';

export const RangeSlider = (props: RangeSliderProps): ReactElement => {
  return <MantineRangeSlider {...props} />;
};
